module.exports = {
          srcSet: __webpack_public_path__ + "/assets/4c930f448e822fd8a28df416bed55f8d-320.jpg"+" 320w"+","+__webpack_public_path__ + "/assets/4073acad3a7f1ac9833f5adb5b7cd524-400.jpg"+" 400w",
          images:[ {path: __webpack_public_path__ + "/assets/4c930f448e822fd8a28df416bed55f8d-320.jpg",width: 320,height: 320},{path: __webpack_public_path__ + "/assets/4073acad3a7f1ac9833f5adb5b7cd524-400.jpg",width: 400,height: 400}],
          src: __webpack_public_path__ + "/assets/4c930f448e822fd8a28df416bed55f8d-320.jpg",
          toString:function(){return __webpack_public_path__ + "/assets/4c930f448e822fd8a28df416bed55f8d-320.jpg"},
          
          width: 320,
          height: 320
        }